import { Component, OnInit } from '@angular/core';
import { Client } from 'src/app/models/clients';
import { ActivatedRoute } from '@angular/router';
import { APIDatasService } from 'src/app/services/apidatas.service';

@Component({
  selector: 'app-client-edit-view',
  templateUrl: './client-edit-view.component.html',
  styleUrls: ['./client-edit-view.component.css']
})
export class ClientEditViewComponent implements OnInit {

  constructor(private route: ActivatedRoute, private api : APIDatasService) { }
  id: string;
  private sub: any;
  client : Client;

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.id = params['id'];

      this.api.getDatas("clients/" + this.id).subscribe(
        res => {
          this.client = new Client();
          this.client = Client.build(res);
        },
        err => {
          console.error("Error finding client id : "+ this.id);
        }
      );
   });
  }

}
